import { useState } from "react";

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

/**
 * Copies text to the clipboard, using navigator.clipboard when available and falling back to an unsecured method otherwise.
 * @returns [CopiedValue string, CopyFn function]
 */
export function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(text);
        return true;
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setCopiedText(text);
        return true;
      }
    } catch {
      setCopiedText(null);
      return false;
    }
  };
  
  return [copiedText, copy];
}
